import { render, staticRenderFns } from "./featurepack_new.vue?vue&type=template&id=4e6b5122&scoped=true&"
import script from "./featurepack_new.vue?vue&type=script&lang=js&"
export * from "./featurepack_new.vue?vue&type=script&lang=js&"
import style0 from "./featurepack_new.vue?vue&type=style&index=0&id=4e6b5122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6b5122",
  null
  
)

export default component.exports